import { addDoc, collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../services/firebase";
import { FIRESTORE_LOYALTY_CLAIMS_TABLE } from "../../../constants/FirebaseConstants";
import useSWR from "swr";
import { useAuthContext } from "../../../context/AuthContext";

export function useLoyaltyClaims() {
  const { authUser } = useAuthContext();
  const { data } = useSWR(authUser ? "loyaltyClaims" : null, async () => {
    if (!authUser) return [];
    // Get user orders from Firestore
    const ordersQuery = query(
      collection(db, FIRESTORE_LOYALTY_CLAIMS_TABLE),
      where("userId", "==", authUser.uid),
      where("cashedIn", "==", false),
    );
    try {
      const querySnapshot = await getDocs(ordersQuery);
      return querySnapshot.docs.map((doc) => {
        return { id: doc.id, ...doc.data() };
      });
    } catch (error) {
      console.error("Error executing query: ", error);
      return [];
    }
  });

  const addLoyaltyClaim = async (claim) => {
    const docRef = await addDoc(
      collection(db, FIRESTORE_LOYALTY_CLAIMS_TABLE),
      claim,
    );
    return docRef.id;
  };

  return {
    data,
    addLoyaltyClaim,
    loading: !data,
  };
}
